type EventColor = {
  bg: string;
  border: string;
  solid: string;
};

const hashString = (value: string): number => {
  let hash = 0;
  for (let i = 0; i < value.length; i++) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return hash;
};

export const getEventColor = (key: string): EventColor => {
  const normalizedKey = key?.trim() || "default";
  const hash = Math.abs(hashString(normalizedKey));

  // Golden-angle distribution for strong separation between keys
  const hue = (hash * 137.508) % 360;
  const saturation = 76;
  const lightness = 46;

  return {
    bg: `hsl(${hue} ${saturation}% ${lightness}% / 0.28)`,
    border: `hsl(${hue} ${saturation}% ${lightness}% / 0.55)`,
    solid: `hsl(${hue} ${saturation}% ${lightness}%)`,
  };
};

// Country code to flag emoji converter
export const countryCodeToFlag = (countryCode: string): string => {
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
};

export const countryCodeToName = (countryCode: string): string => {
  const country = COUNTRIES.find(c => c.code === countryCode.toUpperCase());
  return country?.name || countryCode;
};

export const getCountryFlagUrl = (countryCode: string): string => {
  return `https://flagcdn.com/w80/${countryCode.toLowerCase()}.png`;
};

export const COUNTRIES = [
  { code: "AL", name: "Albania" },
  { code: "AT", name: "Austria" },
  { code: "AU", name: "Australia" },
  { code: "BA", name: "Bosnia and Herzegovina" },
  { code: "BE", name: "Belgium" },
  { code: "BG", name: "Bulgaria" },
  { code: "CH", name: "Switzerland" },
  { code: "CZ", name: "Czech Republic" },
  { code: "DE", name: "Germany" },
  { code: "DK", name: "Denmark" },
  { code: "ES", name: "Spain" },
  { code: "FI", name: "Finland" },
  { code: "FR", name: "France" },
  { code: "GB", name: "United Kingdom" },
  { code: "GR", name: "Greece" },
  { code: "HR", name: "Croatia" },
  { code: "HU", name: "Hungary" },
  { code: "IT", name: "Italy" },
  { code: "ME", name: "Montenegro" },
  { code: "MK", name: "North Macedonia" },
  { code: "MY", name: "Malaysia" },
  { code: "NL", name: "Netherlands" },
  { code: "NO", name: "Norway" },
  { code: "PH", name: "Philippines" },
  { code: "PL", name: "Poland" },
  { code: "PT", name: "Portugal" },
  { code: "RO", name: "Romania" },
  { code: "RS", name: "Serbia" },
  { code: "SE", name: "Sweden" },
  { code: "SI", name: "Slovenia" },
  { code: "SK", name: "Slovakia" },
  { code: "US", name: "United States" },
  { code: "XK", name: "Kosovo" },
] as const;
